import React from 'react';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import cn from 'classnames';

import styles from '../../styles/styles.css';
import { useIsTouchDevice } from '../../../../hooks/use-is-touch-device';

import type { TMenuElementProps } from './models';

export const TopMenuElement = ({
    activeTab,
    analyticsClick,
    analyticsHover,
    currentRef,
    id,
    link,
    onTabClickHandler,
    onTabHoverHandler,
    onTabTouchHandler,
    theme,
    title,
}: TMenuElementProps) => {
    const textKind = theme === 'light' ? 'primary' : 'primaryInverted';

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onTabClickHandler(e, analyticsClick);
    };

    const isTouchDevice = useIsTouchDevice();

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
        <div
            ref={currentRef}
            className={styles.menuElement}
            data-test-id={`test-${id}`}
            onClick={isTouchDevice ? undefined : handleClick}
            onMouseEnter={e => {
                onTabHoverHandler(e, id, analyticsHover);
            }}
            onMouseLeave={e => onTabHoverHandler(e, id)}
            role="button"
        >
            <Link
                dataTestId={`test-${id}-link`}
                href={isTouchDevice ? undefined : link}
                id={`${id}-link`}
                noUnderline
                onTouchEnd={
                    activeTab === id
                        ? () => {
                              if (link) {
                                  window?.location.replace(link);
                              }
                          }
                        : () => {
                              onTabTouchHandler(id);
                          }
                }
                styler={{
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                }}
            >
                <Text
                    className={cn(styles.external, styles.textNoWrap)}
                    kind={textKind}
                    styler={{ margin: 0 }}
                    view="action-primary-medium"
                >
                    {title}
                </Text>
            </Link>
        </div>
    );
};
